<template>
  <div>
    <div
        v-if="agent"
        :class="{ 'ta-wrapper--bottom' : bottom }"
        class="ta-wrapper navbar-expand-lg">
        <div class="container-lg ta-col-wrapper">
            <div
                :class="{ 'ta-left-col--bottom' : bottom }"
                class="ta-left-col px-3 px-lg-0 py-2">
                <div v-if="!bottom">
                    <img :src="agent.display_profile" alt="" class="ta-business-card__image">
                </div>
                <div :class="bottom ? '' : 'ml-4 ml-lg-3'">
                    <h2 class="ta-business-card__name">
                        {{ agent.first_name }} {{ agent.last_name }}
                    </h2>
                    <h1 class="ta-business-card__agency">{{ agent.agency_name }}</h1>
                    <p class="mb-0">
                        <a
                            :href="`tel:${agent.phone_number}`"
                            @click="gtmTrigger('phone')"
                            class="ta-business-card__phone">
                            {{ agent.phone_number }}
                        </a>
                    </p>
                    <ul class="list-inline mb-0 mt-1">
                        <li class="list-inline-item" v-if="agent.email">
                            <a
                                @click="gtmTrigger('email')"
                                :href="setEmail()">
                                <font-awesome-icon
                                    class="ta-business-card__icon"
                                    :icon="['fas', 'envelope']"
                                    width="22" />
                            </a>
                        </li>
                        <li class="list-inline-item" v-if="agent.facebook_page_id">
                            <a
                                @click="gtmTrigger('fbmessenger')"
                                class="d-lg-none"
                                :href="`https://m.facebook.com/messages/compose?ids=${agent.facebook_page_id}`"
                                target="_blank">
                                <font-awesome-icon
                                    class="ta-business-card__icon"
                                    :icon="['fab', 'facebook-messenger']"
                                    width="22" />
                            </a>
                            <a
                                @click="gtmTrigger('fbmessenger')"
                                class="d-none d-lg-inline"
                                :href="`https://www.facebook.com/messages/t/${agent.facebook_page_id}`"
                                target="_blank">
                                <font-awesome-icon
                                    class="ta-business-card__icon"
                                    :icon="['fab', 'facebook-messenger']"
                                    width="22" />
                            </a>
                        </li>
                        <li class="list-inline-item" v-if="agent.website">
                            <a
                                @click="gtmTrigger('website')"
                                :href="`${agent.website}`"
                                target="_blank">
                                <font-awesome-icon
                                    class="ta-business-card__icon"
                                    :icon="['fas', 'globe']"
                                    width="22" />
                            </a>
                        </li>
                    </ul>
                    <div v-if="bottom">
                        <p
                            v-if="agent.agency_license"
                            class="ta-licence">
                            Seller of travel: {{ agent.agency_license }}
                        </p>
                        <p class="ta-copyright">Powered by BranchUp<sup>&reg;</sup> - &copy;<span v-text="setYear()"></span> All rights reserved</p>
                    </div>
                </div>
                <a
                    v-if="menu && (agent.online_suppliers && agent.online_suppliers.length)"
                    href="javascript:void(0);"
                    @click="isMenuActive = !isMenuActive"
                    class="menu__toggle"
                    data-toggle="offcanvas"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <font-awesome-icon icon="ellipsis-v" width="12" height="32" />
                </a>
            </div>
            <div v-if="!bottom" class="ta-right-col py-3 py-lg-2 d-none d-lg-block">
                <img v-if="agent.display_logo" class="ta-logo" :src="agent.display_logo" :alt="agent.agency_name">
                <h1 v-if="!agent.display_logo && agent.agency_name" class="ta-agency-name">{{ agent.agency_name }}</h1>
            </div>
        </div>

        <div
            v-if="menu && (agent.online_suppliers && agent.online_suppliers.length)"
            :class="{ open: isMenuActive }"
            class="navbar-collapse offcanvas-collapse">
            <div class="container-lg">
                <a
                    @click="isMenuActive = !isMenuActive"
                    href="javascript:void(0);"
                    class="offcanvas-collapse__toggle"
                    data-toggle="offcanvas">
                    <font-awesome-icon class="m-3" :icon="['fas', 'times']" width="16" />
                </a>
                <ul class="offcanvas-collapse__menu">
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Destinations</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Cruises</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Hotels</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Flights</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Cars</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Package Tours</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">Special Offers</a>
                    </li>
                    <li class="offcanvas-collapse__menu-item">
                        <a class="offcanvas-collapse__menu-item-link" href="#">About</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { envOptions } from './config';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faEllipsisV, faGlobe, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faEnvelope, faEllipsisV, faGlobe, faTimes, faFacebookMessenger);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    bcardEmail: {
      type: String,
      default: ''
    },
    bcardEnv: {
      type: String,
      default: 'prod'
    },
    bottom: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    emailSubject: {
      type: String,
      default: ''
    }
  },
  data: function() {
      return {
        agent: '',
        agentKey: '',
        isMenuActive: false
      }
  },
  methods: {
    setEmail() {
      let subject = this.emailSubject;
      let email = this.agent.email;

      if (subject) {
        return `mailto:${email}?subject=${subject}`;
      } else {
        return `mailto:${email}`;
      }
    },
    setYear() {
        let date = new Date();
        let year = date.getFullYear();

        return year;
    },
    gtmTrigger(name) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: `bcardClick_${name}`,
                label: this.bottom ? 'bottom' : 'top'
            });
        }
    },
    setAgentData() {
        this.agent = window.agentData;
    },
    setAgentKey() {
      if (this.bcardEmail) {
        this.agentKey = this.bcardEmail;
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        this.agentKey = urlParams.get('email');
      }
    }
  },
  created() {
    this.setAgentKey();

    window.addEventListener('bcardData', this.setAgentData);
  },
  mounted() {
    if (!this.bottom) {
        axios
        .get(`${envOptions[this.bcardEnv]}api/profile_details/0/?email=${this.agentKey}`)
        .then(response => {
            window.agentData = response.data;
            window.dispatchEvent(new Event('bcardData'));
        });
    }
  }
};
</script>

<style lang="scss">
    $body-color: #666;
    $link-color: #477FA8;

    @import "~bootstrap/scss/bootstrap.scss";
    @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap');

    .ta-wrapper {
        background: #fff;
        border-bottom: 2px solid $body-color;
        color: $body-color;
        font-family: 'Source Sans Pro', sans-serif;
        line-height: 1.5;

        &--bottom {
            border-bottom: 0;
            border-top: 2px solid $body-color;
        }
    }

    .ta-col-wrapper {
        padding-top: .25rem;
        padding-bottom: .25rem;

        @include media-breakpoint-up(lg) {
            align-items: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
    }

    .ta-left-col,
    .ta-right-col {
        flex: 1;
    }

    .ta-left-col {
        align-items: center;
        display: flex;
        justify-content: left;
        position: relative;

        &--bottom {
            justify-content: center;
            text-align: center;
        }
    }

    .ta-right-col {
        text-align: right;
    }

    .ta-logo {
        max-width: 210px;
        max-height: 110px;

        @include media-breakpoint-up(lg) {
            max-width: 150px;
        }
    }

    .ta-agency-name {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0 auto;
        max-width: 210px;
    }

    .ta-licence,
    .ta-copyright {
        font-size: .75rem;
        margin: .75rem;
    }

    .ta-business-card {
        &__image {
            border-radius: 8px;
            box-shadow: 0px 0px 22px -4px rgba(0, 0, 0, 0.4);
            height: 100px;
            object-fit: cover;
            width: 100px;
        }

        &__name {
            color: $body-color;
            font-size: 1.25rem;
            font-weight: bold;
            letter-spacing: 0.03em;
            margin-bottom: .3125rem;
        }

        &__agency {
            color: $body-color;
            font-size: .75rem;
            letter-spacing: 0.1em;
            margin-bottom: .3125rem;
            text-transform: uppercase;
        }

        &__phone {
            color: $link-color;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: 0.05em;
            margin-bottom: .3125rem;
        }

        &__icon {
            margin-right: .5rem;
        }
    }

    .menu {
        &__toggle {
            align-items: center;
            bottom: 1rem;
            display: flex;
            flex-direction: column;
            position: absolute;
            right: 1.125rem;

            @include media-breakpoint-up(lg) {
                display: none;
            }

            &--footer {
                display: none;
            }
        }
}

    .offcanvas-collapse {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 100%;
        width: 100%;
        padding-right: 1rem;
        padding-left: 1rem;
        overflow-y: auto;
        visibility: hidden;
        background-color: rgba(0, 0, 0, .8);
        transition: visibility .3s ease-in-out, -webkit-transform .3s ease-in-out;
        transition: transform .3s ease-in-out, visibility .3s ease-in-out;
        transition: transform .3s ease-in-out, visibility .3s ease-in-out, -webkit-transform .3s ease-in-out;
        z-index: 100;

        @include media-breakpoint-up(lg) {
            background: #EEEEEE;
            bottom: inherit;
            left: inherit;
            padding: 0;
            position: relative;
            top: inherit;
            transition: none;
            visibility: visible;
        }

        &.open {
            @include media-breakpoint-down(md) {
                visibility: visible;
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
            }
        }

        &__toggle {
            color: #fff;

            &:hover {
                color: #fff;
            }

            @include media-breakpoint-up(lg) {
                display: none;
            }
        }

        &__menu {
            font-size: 1.125rem;
            font-weight: bold;
            list-style: none;
            padding-left: 0;
            text-align: center;

            @include media-breakpoint-up(lg) {
                display: flex;
                font-size: .875rem;
                font-weight: normal;
                justify-content: space-between;
                margin-bottom: 0;
                text-align: left;
            }
        }

        &__menu-item {
            margin-bottom: .75rem;
            position: relative;

            @include media-breakpoint-up(lg) {
                display: inline-block;
                margin-bottom: 0;
            }
        }

        &__menu-item-link {
            color: #fff;
            display: block;
            padding: .25rem;

            &:hover {
                color: #fff;
            }

            @include media-breakpoint-up(lg) {
                color: #444;

                &:hover {
                    color: #000;
                    text-decoration: none;

                    &:before {
                        content: '';
                        background: $link-color;
                        height: 3px;
                        display: block;
                        width: 100%;
                        position: absolute;
                        top: 0px;
                        z-index: 100;
                        left: 0;
                    }
                }
            }
        }
    }
</style>
